// extracted by mini-css-extract-plugin
export default {"container":"style_container__fqp37","wrapper":"style_wrapper__XBb9q","wrapperFull":"style_wrapperFull__FU1zA"};